import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import "./App.css";
import api from './api';

const theme = createTheme();

function HostLogin({ setIsAuthenticated }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    console.log('Organizer login button clicked');

    try {
      const response = await api.post('/api/login/host', {
        email: email,       // hostId → email
        password: password
      });

      console.log('Login successful:', response.data);
      const token = response.data.access_token;

      // sessionStorage に保存
      sessionStorage.setItem('token', token);
      sessionStorage.setItem('host_email', response.data.email);
      sessionStorage.setItem('is_host', 'true');

      setIsAuthenticated(true);

      // 主催者用のダッシュボードに遷移
      navigate(`/host-dashboard/`);
    } catch (error) {
      console.error('Login failed:', error.response ? error.response.data : error.message);
      setErrorMessage('ログインに失敗しました。メールアドレスまたはパスワードが正しくありません。');
    }
  };

  // return (
  //   <ThemeProvider theme={theme}>
  //     <Box
  //     sx={{
  //       backgroundImage: "url('/login-bg-host.png')",
  //       backgroundSize: 'cover',
  //       backgroundRepeat: 'no-repeat',
  //       minHeight: '100vh',
  //       py: 4,
  //     }}
  //   >
  //     <Container component="main" maxWidth="100%" sx={{ minHeight: '80vh' }}>
  //       <CssBaseline />
  //       <Box sx={{ display: 'flex' }}>
  //         <Box sx={{padding: 5 , textAlign: 'right' }}><img src="/logo.png" alt="logo" style={{ width: '60%' }}/></Box>
  //         <Box 
  //           sx={{
  //             width: '35%',
  //             display: 'flex',
  //             flexDirection: 'column',
  //             alignItems: 'center',
  //             backgroundColor: '#f8f8ff',
  //             padding: 3,
  //             borderRadius: 2,
  //             boxShadow: 3,
  //             mt: '40px'
  //           }}
  //         >
            
  //         </Box>
  //       </Box>
  //     </Container>
  //     </Box>
  //   </ThemeProvider>
  // );
  return (
    <Box
      sx={{
        minHeight: '100vh',
      }}
    >
      <CssBaseline />
      <div style={{display: 'flex'}}>
        <div style={{width: '35%',textAlign: 'right', padding: '15% 0', height: '100vh' }}>
          <div style={{ width: '60%', margin: '0 auto' }}>
            {/* <img src="/messe-icon.png" alt="icon" style={{ maxWidth: '100%', height: 'auto' }}/> */}
            <img src="/logo.png" alt="logo" style={{ maxWidth: '100%', height: 'auto' }}/>
            <Typography>しんきんビジネスフェア<br />出展者申請システム</Typography>
          </div>
        </div>
        <div style={{width: '65%', backgroundColor: '#efefef', padding: '15% 0', height: '100vh'}}>
          <Box component="form" onSubmit={handleLogin} noValidate sx={{ margin: 'auto', width: '80%' }}>
            <div>
              <p className='m-b-0'>メールアドレス<span className='required-srt'>*</span></p>
              <TextField
                margin="normal"
                required
                fullWidth
                id="host_id"
                name="host_id"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                sx={{ mt: 0 , backgroundColor: '#FFFFFF' }}
              />
            </div>
            <div>
              <p className='m-b-0'>パスワード<span className='required-srt'>*</span></p>
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                sx={{ mt: 0 , backgroundColor: '#FFFFFF' }}
              />
            </div>
            <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }} className='login-button'>
              ログイン
            </Button>
            {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
          </Box>
        </div>
      </div>
    </Box>
  );
}

export default HostLogin;
